module.exports = __webpack_public_path__ + "static/media/au-ta.6bb261b3.svg";